var accessToken = php_vars.instagramApiKey;
if (accessToken) {

    fetch('https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink&access_token=' + accessToken)
    .then(response => response.json())
    .then(data => {
    var images = data.data.filter(photo => photo.media_type === 'IMAGE').map(photo => {
        return `<div class="swiper-slide"><a href="${photo.permalink}" target="_blank"><img class="instagram-img" src="${photo.media_url}" alt="Instagram Image"></a></div>`;
    }).join('');

    jQuery('#instagram-swiper-wrapper').html(images);

    // initialize Swiper
    function initializeSwiper() {
        var mySwiper = new Swiper('#instagram-feed', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        loopFillGroupWithBlank: true,
        slidesPerView: 5.5,
        centeredSlides: true,
        spaceBetween: 10, // adjust this value to increase/decrease space between slides
        autoplay: {
            delay: 2000,
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
            slidesPerView: 1.5,
            spaceBetween: 10
            },
            // when window width is >= 480px
            480: {
            slidesPerView: 2.5,
            spaceBetween: 20
            },
            // when window width is >= 640px
            640: {
            slidesPerView: 3.5,
            spaceBetween: 30
            },
            // when window width is >= 768px
            768: {
            slidesPerView: 4.5,
            spaceBetween: 40
            },
            // when window width is >= 1024px
            1024: {
            slidesPerView: 5.5,
            spaceBetween: 50
            }
        }
        });
    };
    if (document.getElementById('instagram-feed')) {
        initializeSwiper();
    }

    });
}   
